import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import ThemeProvider from "react-bootstrap/ThemeProvider";
import ReactDOM from "react-dom/client";

import PromisifiedDialogProvider from "./providers/PromisifiedDialogProvider";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-typeahead/css/Typeahead.css";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/bootstrap4-light-blue/theme.css";
import Router from "./components/Router";
import { msalConfig } from "./config/authConfig";
import "./i18n/i18n";
import reportWebVitals from "./reportWebVitals";
import GlobalStyles from "./styles/GlobalStyles";
import { NotificationProvider } from "./context/NotificationContext";
import { ModalProvider } from "./context/ModalContext";

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);

root.render(
    <MsalProvider instance={msalInstance}>
        <PromisifiedDialogProvider>
            <ModalProvider>
                <NotificationProvider>
                    <ThemeProvider>
                        <GlobalStyles />
                        <Router />
                    </ThemeProvider>
                </NotificationProvider>
            </ModalProvider>
        </PromisifiedDialogProvider>
    </MsalProvider>
);

reportWebVitals();
